var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSharedConversations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 702.8 354.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2}.cls-1,.cls-14,.cls-16,.cls-18,.cls-2,.cls-22,.cls-23,.cls-25,.cls-27,.cls-29,.cls-3,.cls-30,.cls-31,.cls-33,.cls-4,.cls-40,.cls-42,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-51,.cls-53,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-61,.cls-7,.cls-8{stroke-width:0}.cls-2{fill:#a6a6a6}.cls-3{fill:#282828}.cls-4{fill:#656565}.cls-6{fill:#5b5b5b}.cls-7{fill:#3a3a3a}.cls-8{fill:#1a1a1a}.cls-14{fill:#9f9f9f}.cls-16{fill:#9b9b9b}.cls-18{fill:#9e9e9e}.cls-22{fill:#4b4b4b}.cls-23{fill:#111}.cls-25{fill:#bfbfbf}.cls-27{fill:#313131}.cls-29{fill:#d0d0d0}.cls-30{fill:#5c5c5c}.cls-31{fill:#bebebe}.cls-33{fill:#cccccb}.cls-40{fill:#949494}.cls-42{fill:#272727}.cls-44{fill:gray}.cls-45{fill:#222}.cls-46{fill:#858585}.cls-47{fill:#b9b9b9}.cls-48{fill:#1b1b1b}.cls-51{fill:#d1d1d1}.cls-53{fill:#212121}.cls-57{fill:#3b3b3b}.cls-58{fill:#515151}.cls-59{fill:#6b6b6b}.cls-60{fill:#4c4c4c}.cls-61{fill:#393939}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M551.8 202.5V185H197.1l-.8 9.2c-.4-2.9.5-6-.7-9.2h-44v76.6c0 1.9-.3 3.8.5 5.6-.2 1.7-.5 3.4-.5 5v76l-.2 4c-2.4.6-4.5.6-6.6 0-.8-1.3-.5-2.6-.5-4V298c0-1.3.3-2.7-.7-3.8.2-1.6.6-3.2.6-4.8v-64c0-1.3.2-2.6-.6-3.8 1-1 .6-2.2.6-3.3v-29.6c0-1.1.3-2.3-.7-3.7H91c1.3-.8 2.8-.5 4.2-.5h44.7c1.3 0 2.7.3 4.2-1.1v-26.4l.2-.1h69.5c1.7 0 3.6.3 5.3-.5h10.3c5 1.1 10.2.4 15.4.4 1.3 0 1.6-1 1.6-2.2V151.7c0-.2 0-.4.2-.5h.6c-.3 1.6-.4 3.2.3 4.8 2 .5 3.7 1 4.7-1.5.2 1.4 1.1 1.8 2.4 1.8h165.8c3.2 1.2 6.5.4 9.8.5h151.5c1.3 0 2.6.3 3.8-.6l.2-.5c5.5 1.3 11 .3 16.5.6 2.3.8 4.6.9 6.9 0h28.8c5.1-.3 10.3.7 15.3-.6 3.5 1.6 7.4-.3 11.4 1.4v82.5c2.4 1.2 4.3.6 6.2.8-1.8 1-4 0-6.2 1.6v7.6c.2 3-.4 6.2.4 9.4 3.7.5 7.3.5 10.8 0l.2.3c-3.5 1.5-7.3 0-11.5 1v85.2c.3 2.7-.4 5.5.7 8.6h22.7c-.6.2-1.2.6-1.8.6H652l.1-.5c1.7-.2 3.4.4 5.1-.6v-8l.2-2.6v-80.6l-.2-2.5c1.3-6.2.6-12.3.2-19h-6.5c1.8-1 4.2.2 6.3-1.4 0-3.4.6-7-.4-10.4l.5-1.3c.2-.7.5-1.5.5-2.2L657 187c0-.6-.3-1-.4-1.4-1.1-1-2.2-.8-3.2-.8h-53.7c-1.1 0-2.3.5-3.4.7-.7-.7-1.7-.7-2.6-.7h-34.3c-2.2.2-4.5-.6-7 1v16.7h-.7Z",
    className: "cls-46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m657.2 227.7-.5 1.3a31 31 0 0 1-9.3 10.7l-.6.6c-10.2 6.6-23.6 2.4-34.8 2.2-12.3-.2-25 .3-37.2 2.4v.6l1 4c6.6 25.6 15 50.3 28.7 73 4.7 8 4.4 13.7-1.4 20.7-.5.7-1 1.3-.7 2.2-.1 0-.2 0-.3.2-1.4-.7-2.3.4-3.4 1-6.8 3.4-13.4 3.7-19.8-1.1-1-.8-2.2-1.6-3.6-1.7 1-.7.6-1.3 0-2-6-9.7-11-19.9-15.5-30.3l-7.4-18.5c.2-.8 0-1.6-.4-2.4a291.7 291.7 0 0 1-11-35.2l-1-3.5c-.3-5.9-1.4-11.7-1.3-17.6.2-13 6-20.5 18.8-22.6 12.1-2 24.4-2.7 36.6-3.4 4.5-.3 9-.1 13.3-1.2l2.1 2.3c10.5 12.4 29.2 14.5 40.9 4.7 2.5-2.2 4.1-5.1 6.8-8.2v21.8Z",
    style: {
      fill: "#242424",
      strokeWidth: 0
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.4 156.3h-45.8c.5-11.4-2-22.4-5-34l-17.3 19.1c-6.8 7.5-14 6.7-18.8-2.2a107 107 0 0 1-9.7-38.8l-.6-6.5c3.6 2 6.4.9 8.7-2.2l2.6-4c2.4 12.5 4.6 25 9 37.2l9.4-11c6.8-8.2 13.2-16.7 20.6-24.5 4.4-3.2 9.3-5.3 15-7.2V69.3l.3.1c-.3 4.6 1 9.2-.4 13.6a10 10 0 0 0 2.8 11c2.7 2.6 5.8 4.8 9.4 6.2 5.4 2.3 10.4 1.4 12.4-2 2-3.3-.1-8.7-4.5-12.1-1.2-1-3-1.2-3.5-3 4.1 1.5 7.7 3.9 11.4 6.3 3.3 4.3 8.5 5 13.2 6.8l31 10C458 93 452.9 81.6 448 70c2.4.7 4.8 1.7 7.2 2.2 2.5.6 5 .4 5.9-2.8 6.6 13.1 13.5 26 15.6 41l.4 3.9c.2 8.5-5.3 13-13.6 10.7-11-3-21.8-6.2-32.7-9.3l-7-2-3.3 42.6Z",
    className: "cls-40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M607.4 207c-4.3 1.2-8.8 1-13.3 1.3-12.2.7-24.5 1.5-36.6 3.4-12.8 2-18.6 9.7-18.8 22.6-.1 6 1 11.7 1.2 17.6a504.3 504.3 0 0 0-22.3 83.1c-1 6-4.1 10.1-9.5 12.8l1.2 5.5c-1 1.5-2.3 1.3-3.5 1.3l-27.5-.6c-1 0-2-.2-3-.4-2.3-.6-4.3-1.7-4.5-4.3 0-2.5 2-3.5 4-4.2l10.8-3.3c-5.2-9.8-1.3-19.3.6-28.7a568.4 568.4 0 0 1 22.2-77.5c1.9-5.4 4.6-10.5 7.3-15.5 5.9-11 15.2-16 27.3-16.9l8.8-.7h.6l7.5-.5c11.2-1 22.4-1.7 33.7-1.8h9.3l4.5 6.9Z",
    className: "cls-23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M481.6 233.3c3 4.8 3 10 1.8 15.1a289 289 0 0 1-22.6 59.4 373.7 373.7 0 0 1-18.4 33.6l12.3 4.1c2 .7 4.7 1.3 4.3 4.1-.4 2.7-3 3.5-5.3 3.4-17-.2-34 .8-51-.1-2.3-2.8-.7-6-1.2-9 .2-1.4 0-3 .6-4a239 239 0 0 0 29.7-88.1c.4-3.1 2.4-4.6 5.1-5.8l19.5-9.1 2.3 7.6c3.7 0 8.5-3.3 12-4.9 2.8-1.3 9.9-3 11-6.3ZM455.3 262l1.2-5.2-.6-.2-1.1 4.3c-9 28.2-21.4 54.7-36.4 80.6l7.1 2.3c-.4-2.7.8-4.5 1.9-6.4a235.7 235.7 0 0 0 28-75.4Z",
    className: "cls-42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M670.8 240.4c-1.8-.3-3.8.3-6.2-.8V157c-4-1.7-8 .2-11.4-1.5-2.1-15.5-2.6-31 4.1-45.6 3-6.3 2-11.7-1.2-17.3l34.8.2c-2.6 3-2.9 6.7-2.9 10.5v128c0 6.1-2.5 8.7-8.6 8.9h-8.6Z",
    className: "cls-25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3 211.3c3.8 0 7.6.2 11.4.4 2.5 0 3 1.8 3.8 3.8 6.3 15.2.5 29.8-2.4 44.4-4.6 24-11 47.8-14.7 72.1-.3 1.7-1 3.3-1.5 4.9-5 6.9-11.3 8.3-19 5.2l-2.4-2.2c-4.3-4.5-3.8-10-3-15.4 3.4-23.2 5.3-46.5 7.7-69.8l1-10.3c-5.6 0-10.7-.9-15.8.5l.5-1.2h15c2-6.7 1.5-13.8 3.2-20.5.7-2.6 2-5 4-6.8 1-1 5.9-2.9 4.7-4.6 2.5-.2 5 .4 7.5-.6Z",
    className: "cls-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m234 243.8-.6 1.2-1.7 9.8-4.6 21-.6 1.2-.1 3.4c-4 16.3-7.5 32.7-10.2 49.3-.4 2.5-.7 5-2.3 7.2v1.2c-2.4 2-4.7 4.3-8 5.2-5.3 1.5-9.5-1.1-13.8-3.5-4.9-9-1.4-18-.5-27l5.8-54.2 1.3-13.7-2.6-1.1c1-.1 2 0 2.1-.2 3.8-10.3-.5-22.5 10.5-29.7l-1.6-1c9.5-2.6 19 0 28.5 0l-7.2 1c10.4 7.5 7.1 19 5.5 29.8Z",
    className: "cls-3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M656.1 92.7c3.2 5.6 4.1 11 1.2 17.3-6.7 14.7-6.2 30.1-4 45.6-5.1 1.4-10.3.4-15.4.6-2.5.2-5.1 0-7.7 0l.2-.5.4-.5 11.4-20-20-11c-2.4 3.2-3.1 7-6 10-7-11.8-13-24-19-36.3l5.6-8c2.4-1.3 3.4-3.8 4.4-6.5 3.9 3.8 7.9 4.7 12.3 2.4 4.6-2.3 7.8-5.7 7.3-11.4h1.2a64.6 64.6 0 0 1 28 18.3Z",
    className: "cls-4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 246H14.3c-5.7 0-8-2-8-7.9V110.4c0-4.6.2-9.2 1.3-13.6 4-5.4 9-8.1 16-7.6 6.7.6 13.3.2 20 .2v.5h-25c2.4 4 2.2 7.5 2.2 11v128.3c.2 3.5 1.5 7 5.1 7.3 8.3.6 16.7 1.3 25 .5l36.7 8.5c-1 .2-2 .5-3 .5l-17.6.2H32.7L29 246ZM670.8 240.4l8.6-.1c6-.2 8.6-2.8 8.6-8.9v-128c0-3.8.2-7.5 2.9-10.5 4.1-.2 6.7 2.4 8.9 5.4 2.4 3.3 3 7.3 3 11.4v129.9c0 7.8-1.7 9.5-9.5 9.5l-15.4.1c-.4 0-.7.3-1 .4-1 3.2.4 6.5-.9 9.6l-.2-.2v-9.6c-4-.5-7.6-.8-11.2.1V242c2.2-1.7 4.5-.6 6.2-1.6Z",
    className: "cls-44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.6 221.5c.8 1.2.6 2.5.6 3.8v64c0 1.6-.4 3.2-.6 4.8-5.4 13.7-12.9 26.5-19.4 39.7l-2.3 4.9c-1.7 3-3.5 5.6-7.3 5.8-6.3-.3-7.8-1.4-8.2-5.8l1.6-3.7c12.6-26.4 21.3-54 25-83 .2-2.2 0-4.2-1.4-6-1-.5-2-1.2-2.8-1.8-1-.5-1.6-1.2-1.9-2.4-1.8-7.3-6.9-12-13.2-15.6-7-4-15-5.1-22.1-8.8l-.5-7.6.7 4.9 19.2 1c11 1 22.2 1.2 32.6 5.8Z",
    className: "cls-53"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260.8 156.3h-6.2c-1.3 0-2.2-.5-2.4-1.8L254 138l3 1.3 13-18.4 7.8 6c1.8-1.9 2.3-4.7 3.1-7a143.6 143.6 0 0 0 6.6-31.2c.7-6 2.6-11.3 5.9-16.2a60.7 60.7 0 0 1 12.2-14c6.2 1.8-3.6 8.4-4.3 11.4 3.7 2.4 11.5 5.5 11.2 11-.2 2.3-2.6 3.8-3.8 5.7-1.3 2-2 4.2-2.6 6.4-1.1 4.9-1 10-1.4 14.9-.6 5.8-1.4 11.6-2.7 17.3-1.2 5.5-2.9 11-5.2 16-2 4.8-4.7 10.7-9.5 13.3-9.3 5-19.8-5.2-26.5-10.5v12.3Z",
    className: "cls-33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 89.3c-6.6 0-13.3.5-20 0-7-.7-12 2-16 7.5a33.8 33.8 0 0 1-3.4-37.4c6.5-13 17.8-19 32.4-19.8V33c0-1.7 0-3.6 1.3-4.8 5.7-5.7 11.6-11 20-12.6 10.5-1.8 22.8 11.3 21 20.5-5-11.4-25.8 4-32 7.4-.6 3 1 6.1 0 9-1.2.7-1.9.1-2.6-.2l-2.8-4.6c-3.8 2.4-2.4 5.2-1.3 8l-.6.7c-4.1-3.4-2.7-8.3-3.2-13.2C24.4 65.8 27 76 42.8 83.8c1.4 1.7.8 3.7.7 5.6ZM589.1 25.8c-.2-15.3 4.6-20 20.1-20.2 8.4-.2 16.3.5 23 6 1.3 1.1 2.2 2.2 2.6 3.7a54.1 54.1 0 0 1-2.3 31.4c-1.2 3.6-4.8 6.3-6.2 10.1-4.9-.6-5.2 5-7.3 8-3 4-7.6 4.8-12.3 5.6l-3.3.1c-13.3-.8-14.8-2.3-15-15.8 0-2.7-.7-5.5.8-8.1 11.9.5 24.6-12.5 21.8-22.6-6-1.4-11.7-5-18-4.2-2.2 1.7-2.5 4.2-3.9 6Zm27 5.7c.8 4.1 1.8 8 1.7 12.4 4.2-2.8 5.8-15.1-1.7-12.4Zm-24.7 23.3c2.9-.4 5-1.7 6.4-4.7H590c0 1.7.4 3.2 1.3 4.7Z",
    className: "cls-27"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M585.5 156.2c-1.2.8-2.5.6-3.8.6H430.2l-.1-.5h129.2a87.5 87.5 0 0 1-21.7-32c-2.5-6-4.6-12-6.7-18-1-3-2-5.3-4.3-7.5-2-1.8-6-3.4-7.2-5.8l1-2.4-2.3-1.4c1.6-4.2 5.4 1 8.3.2-2-2.8-5.8-2.6-7.4-5.2.1-1.4 1-1.6 2-1.7l7.2 3.9.5-1-6.6-3.4c-.4-1-.3-1.7 1-2.3 4.5 1.3 8.5 4 12.8 6.2 4.2-1.6 5.3-1.1 5.6 3.4.6 7.2 5.6 12.4 8 18.8 2.7 7.4 7 14 11.8 21.2l5.9-11.4c.3 1.4 1.5 2 2.6 2.4 6.9 2.4 10.5 7 10.6 14.5 0 2 .8 4 1.2 6-1.3-.2-1.6 1-2 1.7-3 5-5 10.8-10.9 13.7h16.8ZM597.1 98c6 12.2 12 24.4 19 36.2 3-3 3.7-6.8 6.2-10l19.9 11-11.4 20-.4.5-.2.6h-21.1l-.6-.6-4.6-5.6c-8.3-11.6-12.8-25-18-38-1.9-4.9-5.3-8.9-10.5-10.7-1.4-1.4-.6-2.6.3-3.7-.6-1.1-2.7-1.4-1.6-3.3 1.6-1 3.1 1.2 4.6.1.4 1.3 1.1 2 2.7 1.7-.4-1.5-1.6-1.6-2.7-1.7-1-1.8-4-1.5-4.4-4.3 2.5-1.9 4.2 1 6.2 1 1 1 1.9 1.8 3.7 1.6a4.2 4.2 0 0 0-3.7-1.7c-1-1-2.1-2-3.5-3.1 1.7-2.9 3.6-.3 5.2-.3l9.2 5.1c1.3-.9 2.6-1.6 4.1-.7 1.6 1.3.8 3.3 1.5 4.8l.1 1Zm-19.4.6c0 .7.4.7.9.6 0-.6-.4-.7-1-.6Z",
    className: "cls-25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.6 213c-9.5-.2-19-2.7-28.5 0-5.2-1-8.8-3.8-10.3-8.8-3 8-4.9 16-4 24.4.2 2.4 0 4.8 0 7.2-3.3 1-6.6.3-9.8.5.2-1 .5-2 .5-3v-48.4h12c1.3 3.2.4 6.3.8 9.3v4.3c8.9-2 15.1-6.6 19.8-13.6h31c-1.2 8.6-.5 17.2-.4 26.3h21.6c-2.4 1-5 .5-7.5.7-8.4-.6-16.8-.1-25.2 1Z",
    style: {
      fill: "#a5a5a5",
      strokeWidth: 0
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7 246.1h34.2v9.6c2 1 3.8.1 5.2 1.3.8 1.2.5 2.6.5 3.9v60.5c0 1.4-.3 3 .7 4.2-2.1 3.1-4.3 6.2-6.2 9.5-3 4.9-2.9 10.2-1.9 15.6l.6.6H22.6L21 351c0-2.8-1-5.6.6-8.4h36.7c.8 0 1.6-.4 2.4-.6v-85.6H36.8c-1.2-.2-2.5.2-3.8-1-.7-2.9-.2-6.1-.3-9.3Z",
    className: "cls-61"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M229.3 156.3H180.3l-.6.5h-35.3l-.2-.5h31.7l.1-.4-2.4-.6c-8.2-1.6-11.1-7.4-7.5-15.1l9-18.8c6.3 3.1 12.6 6 18.4 9.9v.4l-.5.7-.2.4-.4.7-.2.5-.4.6-.6.8v.3l-.5.8-.1.3-.5.8-.2.4-.4.7c0 .1 0 .3-.2.4l-.4.7v.5l.1.4 5.6.2 3 .4h25l.6.1h3.3l5.8-5.1c1.6-1 2.5-2.9 4.6-3 .6.8 1.6 1.3 1.4 2.6 0 .7-1.4 1.2-.8 2.6H246l3 .5.5.5v.7l-.1.6v.6h-.6l-.5.5-1.7.1h-.6l-4.4.6v.5h8.4l.6.6.5.5v1.2l-.6.5a1 1 0 0 1-.4.2c-1.2-.1-2.5-.3-3.6.5h-5.1v1h5.1l2.3.7.5.5v1.2l-.5.6-.5.4-1.1.1h-.7l-.7.1.2.5.4.5v1.8l-.5.5-2.8.6c-1.4 0-2.8-.2-4 .6h-.6l-.6.5h-8.6Z",
    className: "cls-33"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8 70.6c-.8-3.8-.3-7.7-.5-11.6v-9l.6-3c2.5-4.2 3.6-8.6 2.4-13.4 5.7-5.5 12.2-5.8 19-3.6 4.2 1.4 8.3 2.8 12.9.8a298 298 0 0 1 1.2 5.5V53c0 8-3.6 14.1-10.2 18.5-3.5 2.4-1.9 6.3-3 9.3-3.8 3.9-5.2 9.2-9 13.5-2-2.4-3.7-4.7-5.8-6.9-2.5-2.6-4-6.2-7.5-8v-6.1c8.7 4.4 16.7 4.5 20.5.2-8.2-1.3-15-5.1-20.6-12.8v9.8Zm20.8-29c-1 3.9 1.4 6.5 1 9.3-.8 1.2-2.5.4-3.2 2 2 .7 3.9.8 6-.4-1-3.5-1.4-7-3.8-11Zm13.3-2.8c-1.8-4-9.7-4-10 .9 3.3-2.4 6.5-2.3 10-1Zm-17.1-4.9c-3.1-2.3-10.4.7-8 5 1.7-3.2 4.5-4.6 8-5Zm1.9 25.1-6.8-2.2c1.5 3 3.8 3.6 6.8 2.2Zm9-15.9c1.1.6 2.2.8 3.1-.5.1-1.3-.4-2.2-1.8-2.4-1.4.5-1.9 1.4-1.3 3Zm-13.6.3c.6-3.6-4.2-3-3 .2 1 .7 2 .6 3-.3Z",
    className: "cls-25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 52.2c.8.3 1.5.9 2.6.2 1.1-3-.5-6 .1-9 6.2-3.4 27-18.9 32-7.4l.8 5.3c-3.4-1.5-6.5-1.8-9.4 1.1 3.4-1.9 6.7-.6 10 0-1 3.5-.6 7-.7 10.5 0 15-4.8 21.7-19.2 26.3l-.6 9.7c5.3 1.3 10.4-.4 15.3 1H60l-.4 4c-.3 3.1-2.4 5-4.2 7.2-2.8-4.3-4.6-5.7-11.8-9.5v-2.3c0-1.8.7-3.8-.7-5.5a93 93 0 0 0 .1-24.7c.9-.6.6-1.5.6-2.3 0-1.5-.3-3.2.6-4.7Zm15.4 26.1c-6.8-2.6-11.6-7-15.4-14.4v13.7c0 1.3.7 2.2 1.8 2.8 3.2 2 10.1 1.1 13.6-2ZM70 60.1c-.5-3.8-1-7.5-3.3-11.6-1.4 4 1.3 7 .7 9.8-1 1.3-2.7.1-3.3 1.9 1.9 1 3.7.8 5.9-.1Zm-1.5 3.7c-3.6 0-6.6-.5-9.8.3 2.5 3.6 7.3 3.6 9.8-.3Zm6.3-11.5c2.5-.8 1.7-2.9 2.4-4.3-1.2-.4-2.1-.5-3.3 0-1.1 1.6-1.2 3.1 1 4.3Zm-15.6-4.8-3 .2c.7 1.6-.1 3.7 2.3 4.4 2.1-1 2.1-2.5.7-4.6Zm5.1-4.3c-3.3-4-9-3.9-10.5-.5 3.3-1.7 6.5-1.7 10.5.5Z",
    className: "cls-51"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M367.8 32.2C365.9 17.8 377.9 6 394.3 6.1c4.8-6.5 9.7-7.3 14.6-4.6 5.3 2.9 7 9.3 4.7 16.7 5.4 14.6 2.3 26.1-8.6 32.3h-.6c1.7-8-5.6-12.8-6.8-19.8a73 73 0 0 1-25-8c-2.5 2.5-4 5-3.3 8.3 3 .5 6.4-.9 9.6 2.5-3.7-1.3-6.5-1.9-9.3-.5-1 .5-1.4-.2-1.8-.8Z",
    className: "cls-8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M367.8 32.2c.4.6.9 1.3 1.8.8 2.8-1.4 5.5-.7 9.3.5-3.2-3.4-6.5-2-9.6-2.5-.6-3.3.8-5.8 3.2-8.3 7.8 4 16 6.9 25.1 8 1.2 7 8.5 11.8 6.8 19.8v2.4a24.3 24.3 0 0 1-13.8 14.3c-1 .4-1.5 1-1.6 2.1l-.2.2-.4-.2c0-.8-.3-1-1.2-1.2-8.5-1.2-16.6-9-17.7-17.5-.8-6.1-.6-12.3-1.7-18.4Zm16.6 18.5c-1.4-1.2-2.8-.4-3.7-1.7-.1-3 2.3-5.8.9-9-2 3.3-2.9 7-3.4 10.5 2.2 1.5 4 .5 6.2.2Zm-4.8 3.9c1.8 3.2 9 4.5 10.2 0h-10.2Zm-6.4-11.8c3.2-1.4 1-5.5-1.9-3.7-.2 1.6.1 3 2 3.7Zm17.6-.7c1-1 1.2-2 .8-3.3-3.3-2-4.4 4-.8 3.3Z",
    className: "cls-59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M383.7 343.8v-87.4h12v87.4h-12Z",
    className: "cls-61"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m248.9 34.5-.7-3.7c-4.6 2-8.7.6-12.9-.7-6.8-2.3-13.3-2-19 3.5 1.2 4.8.1 9.2-2.4 13.3-2-2.7-.2-6.1-1.5-8.9-3.7-1.8-6-.4-6 3.5 0 4.8 2 7.2 6.9 8.6v9c-8.4-5.5-9.6-18.8-9.7-28-.1-4.5 0-9 3.8-12 3-2.3 4.5-6.1 8.6-7.3 4.6-1.3 10.4-.5 15.2-.5 4.6 0 10.3-.8 14.6.8 9 3.5 7 15.9 4.1 23l-1-.7Z",
    className: "cls-27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 114.2c-1.2 9.3-2 18.7-4.5 27.8-4.3 1.6-8.6-.4-13 .2l-.7 2.8c-.1-1 0-2-1.2-2.9-5-1-10.6-.8-16-1.3 4.5-1.3-6.8-17.7-8.3-20-4.7-7.6-8.6-15.7-14-22.8-.3-.9-1-1.7-.4-2.8l2.1-.1c2.5 1 4.5 2.6 6.3 4.6 4 4.5 8.3 8.9 12.5 13.3 6.2 6.5 12.5 13 19 20a141 141 0 0 0 5.7-21.3c4.4-.3 8.3 1.5 12.4 2.5Z",
    style: {
      fill: "#292929",
      strokeWidth: 0
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m232.2 136.3-5.8 5.1h-3.3l-.5-3.4c-2.5-18.6-8.6-36-16.2-53.1l4.7-1.2c-.4 7.7 1.7 12.1 6.8 13.8 6.8 2.3 15.8.4 18.8-4 5 13.4 7.7 27.2 8.8 41.5v3.5h-8.2c-.5-1.4.9-1.9.9-2.6.1-1.4-.8-1.9-1.4-2.5 1.3-.7 1.6-2 2-3.4 2-8.2.9-16-3.3-23.4-.7-1.2-1.2-2.6-3-3.6a33.5 33.5 0 0 1 3.6 22.3c-.7 4-3.2 7-3.9 11Z",
    className: "cls-14"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.4 84.9c7.6 17 13.7 34.5 16.2 53l-.1 3.5-6.7-.1-18.5-.4h-2.8c-1.8 0-3.7 0-5.6-.2l-.2-.4.1-.5.4-.7.2-.4.4-.7.2-.4.5-.8.1-.3.5-.8v-.3l.5-.8.5-.6.2-.5.4-.7.2-.4.4-.7.1-.4 12.7-22c1.4-2.5 1.9-5 1.3-7.8-2-8.6-11.8-11-19.1-4.6l-.8-.8c2.8-4.3 7.5-5.9 11.6-8.4l7.3-2.8Z",
    className: "cls-45"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M575.3 101.4c5.3 1.8 8.7 5.8 10.6 10.6 5.2 13 9.7 26.4 18 38l-1.5 6.2-.2.1c-5.5-.4-11 .7-16.5-.6l-4.1-14.8c-.4-2-1.2-4.1-1.2-6.1 0-7.5-3.7-12.1-10.6-14.5-1.1-.4-2.3-1-2.6-2.4l8.1-16.5Z",
    className: "cls-4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m101.3 145 .7-2.8c4.4-.6 8.7 1.4 13-.2a39 39 0 0 0 16.5 1c3.8-.6 6.5-6.8 8.6-9.8 1.5 0 2.3.4 2.7 1.6l-1.5 3.3c4.4.6 8.5-2.3 12.7-.6 0 1.6-.9 2-1.8 2.2-2 .5-4.2.2-7 2.2 3.7-.4 6.3-.6 8.7-1.6h1.1l.6.5c1.6 3.6-6.3 3-8 4.5 2.5 1.7 5.5-1.7 7.6.9-.1 2-1.8 1.7-2.7 2.5v2.6c-5.8 2.6-11.9 3.7-18 4.9h-32.8l-.5-4 .2-7.2ZM149 149c.3 0 .2 0 0 0 .2 0 .3.1 0 0Z",
    className: "cls-51"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M188.3 96.9c7.3-6.4 17.1-4 19 4.6.7 2.8.2 5.3-1.2 7.7l-12.6 22c-6-3.7-12.2-6.7-18.5-9.8 2-5.2 4.8-9.8 7.4-14.7 1-1.9 1.7-3.7 1.8-5.9h.5c2.1-.5 2.3-2.7 3.6-4Z",
    className: "cls-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M481.6 233.3c-1 3.4-8 5-11 6.3-3.4 1.6-8.2 4.9-11.9 4.9l-2.3-7.6-1.1-2.3-.6-.5-.6-.6c-2.4-4.1-5.8-7-10.3-8.6l-1.1-.6-3.4-1.7-1.8-.5-.5-.6h-1.2l-.5-.6H434l-.6-.6h-1.7l-.6-.5h-1.7l-1.1-.6h-1.2l-1.1-.6h-2.3l-1.7-.5-2.4-.7 1.2-.4 8-3.5h.5l2.5.5c11.8 1 23.6 2.3 34.7 7 6.2 2.5 11.9 6 15 12.3Z",
    style: {
      fill: "#1d1d1d",
      strokeWidth: 0
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6 342c-.8.2-1.6.7-2.4.7H21.5l7.6-.7v-96l3.6.1c0 3.2-.4 6.5.3 9.4 1.3 1 2.6.8 3.8 1-1.5 14-.3 28.7-.3 42.7 0 14.2-.8 28.7.2 42.8h24Z",
    className: "cls-22"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m352.8 185 14.3-.1a98 98 0 0 0-4.5 26.2c-1.3.7-.7 1.8-.6 2.8 1.4 10 6.4 17.7 14.8 23.2-2 .7-4.3.3-6.4.4-6 .3-12-.6-18 .5 0-17.7.2-35.4.4-53Z",
    className: "cls-25"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m395.6 256.5-12-.1-19-.2c-3 0-5.3-1-6-4.3.3-2-.4-4 .6-5.8 1.3-.9 2.6-.6 4-.6H407c1.4 0 2.8-.3 4.2-.5l14.3 2c-2 .2-1.6 1.7-1.6 3 0 3-1.1 5.3-4.5 5.8-3.7 0-7.4-.2-11 0-4.3.2-8.6-.8-12.7.7Z",
    className: "cls-6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M395.6 256.5c4.2-1.5 8.5-.5 12.7-.7 3.7-.2 7.4 0 11.1 0h-23v88h5c.6 3-1 6.3 1.2 9.1h-57.4c-3 0-4.9-1-5-4.4 0-3.5 2-4.6 5.2-4.6l38.2-.1h12v-87.3Z",
    className: "cls-6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 114.2c-4.2-1-8.1-2.8-12.5-2.5 3.6-12.6 5.2-25.6 9.3-37.8 1.4-.6 2.3-.5 3.3.4l-.4 4.7 11.7-6.5c1.4.6 1.7 1.3 1.3 2.7l-7.8 4.9c4.8-.5 7.2-4.8 11.8-3.8-1.5 4.2-6 4.2-8.3 7.3 3.3.7 5-3 8.3-2.3 1.2 3.7-3.2 3.3-4 5.2l-1.2.6 1.1-.6c1.1-.2 2.2-.9 3.2.1 1.6 2.6-9.8 8.6-11.6 10-2.4 1.6-2.3 4-2.7 6.8l-1.6 10.8Z",
    className: "cls-51"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M404.3 52.9v-2.4h.7V83c.5 1.9 2.3 2.1 3.5 3 4.4 3.6 6.4 9 4.5 12.2-2 3.4-7 4.3-12.4 2A29 29 0 0 1 391 94c-3-3-4-6.6-2.7-11 1.4-4.3.1-9 .4-13.6h.2c3.5 2.8 7.5 3.1 11.7 2.3 2.6-.5 3.7-2 3.6-4.6V52.9Z",
    className: "cls-59"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m352.3 141.4 17.3-19.2c3.1 11.7 5.5 22.7 5 34H353c-.3-4.9.7-9.8-.6-14.8Z",
    className: "cls-25"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M334.5 87.6c-.9 1.4-1.7 2.8-2.6 4-2.3 3.2-5.1 4.2-8.7 2.3-3-6.9-4.3-14.2-5.4-21.5.6-1 1.5-1.2 2.5-.7l2 4.7c-.1-2.8-.5-4.1-1.3-5.4l-.6-2.5c.6-1.5 1.5-1.6 2.5-1.2 2 2.1 1.2 5.5 3.9 7.7.4-2.9-4.1-9.7-.5-11.2 1.4.3 1.5 1.3 2 2.1l2.4 8.3 1-.3-2.4-9.1c.6-.7 1.2-1.3 2.6-.8 2 3.2 2.3 7.3 4 11 1.5-.8 4.4-7.8 6.1-2.5l-7.5 15.1Z",
    className: "cls-59"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m91.4 50.5-6 10.6c-1-.9-.7-1.8-.7-2.6V24.2c0-4.8 1.9-6.8 6.7-6.8H138c4.8 0 6.7 2 6.7 6.8v20c0 4.4-2 6.3-6.3 6.3h-47Zm-4.5 1.8c2-5.1 6-4 9.7-4H138c2.7 0 4.5-.7 4.5-3.8V23.6c0-2.6-1.3-4-4-4H91c-2.8 0-4 1.6-4 4.2v28.5Z",
    className: "cls-47"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M589.1 25.8c1.4-1.8 1.7-4.3 4-6 6.2-.7 11.8 2.8 17.9 4.2 2.8 10.1-9.9 23.1-21.9 22.6v-1.2c.8-.2 2 .3 2.7-1.2l-3.2-1.4c.4-2.2 2.7-7.7.5-9.5v-2.9c3-1 6-1 9.1 1-.8-4-5-4.9-9.1-2.6v-3ZM596 35c.2-1.3.2-2.4-1.6-2.7-1.3.5-1.7 1.4-1.3 2.7.9.8 1.8.8 2.9 0Z",
    className: "cls-25"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M461 69.4c-.9 3.1-3.4 3.3-5.9 2.8-2.4-.6-4.8-1.6-7.2-2.3l-14.1-8.2c-.6-1.8 0-2.6 1.6-3.2l4.9 2.2-3-11.5c2-1.7 3-.7 3.6.7l2 7.4c.4 0 .7-.2 1.1-.3l-2.5-8.2v-2.6c4.6-1.3 4.2 7 6.2 9.4 1.1-3.3-1.4-5.7-.9-8.4.6-1 1.4-1.2 2.8-.5l1 3.2a6 6 0 0 0 1.3 3.8c.3-1.6-.2-2.7-.7-3.8.3-.9.8-1.5 2.3-1.5 3.5 6.5 6 13.5 7.5 21Z",
    className: "cls-59"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M355 34.4h-46.2c-5.3 0-7.3-2-7.3-7.3V7.7c0-4.5 2-6.4 6.5-6.4h47.4c3.6 0 6 1.3 6.1 5.2v36.8l-.4 1.6-6.1-10.5Zm4.6 1.9V7c-.1-2.5-1.8-3.5-4.1-3.5H308c-3 0-4.3 1.4-4.3 4.4v18.8c-.1 4 1.5 5.5 5.4 5.5H350c3.7 0 7.6-.7 9.6 4Z",
    className: "cls-47"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M260.9 211.1h-14.2c0-9-.8-17.6.4-26.2H261v26.2Z",
    className: "cls-25"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m552.4 293 7.4 18.4c-.8 3.5-.3 7-.3 10.6v30.5c-2.4.8-4.6.5-6.6.3-.8-.7-.7-1.6-.7-2.5v-56l.2-1.3Z",
    className: "cls-60"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M411.2 245c-1.4.2-2.8.5-4.2.5h-43.8c-1.3 0-2.7-.3-4 .6-1 1.8-.3 3.9-.7 5.8l-.6-5.8c-3-1.2-6.2.2-9.3-.9-.3-3.2 1.3-5.4 3.7-7.1 6-1.2 12-.3 18-.6 2.2-.1 4.4.3 6.5-.4 3.3 1.8 6.6 3.6 10.2 4.2l24.2 3.7Z",
    className: "cls-44"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M246 342.1c7.6 3.1 14 1.7 18.9-5.2l1.3.5 13.7 4c1.6.6 3.2 1.5 3.2 3.5 0 2.2-1.5 3.2-3.3 3.8-1 .4-2.2.7-3.3.8h-31.1c-2.2-1.9-.2-3.8 0-5.7l.5-1.7Z",
    className: "cls-23"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m420.4 156.3 3.2-42.7 7 2c-1.5 1-1 2.5-1 3.9v36.7h-9.2Z",
    className: "cls-25"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 120.9-12.8 18.4-3-1.3c1-12.3-.3-24.4-2-36.6l8.2 9.7 9 9.3.6.4v.1Z",
    className: "cls-14"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M192.1 339.8c4.3 2.4 8.5 5 13.8 3.5 3.3-1 5.6-3.1 8-5.2h.6l9.8 2.8c3.2 1.3 6.2 4.5 2.2 7.2-3.3 2.2-10 1.2-13.7 1.4-7.6-.2-15.3.8-22.9 0-.7-3.3 1.4-6 1.7-9.1l.5-.6Z",
    className: "cls-23"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M597 96.9c-.8-1.5 0-3.5-1.5-4.8-1.5-.9-2.8-.2-4.1.7l-9.2-5.1a26.4 26.4 0 0 1 20.6-14.4l.6 1.2c-1.4 4.4.7 8.5 1.1 12.6l-2.3 2.3c-2.2 2.1-4.6 4.2-5.2 7.5Z",
    className: "cls-4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M236.7 93.5c-3 4.4-12 6.3-18.8 4-5-1.7-7.3-6-6.8-13.8l2.8-4.1c3.4 1.8 5 5.3 7.5 8 2 2 3.8 4.4 5.8 6.9 3.8-4.3 5.2-9.7 9-13.5a14 14 0 0 1 1.8 6.7c-.4.9 0 1.6.6 2.2-1.5.7-1.6 2.2-1.9 3.6Z",
    className: "cls-58"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M575.3 343.8c1.4.1 2.5.9 3.6 1.7 6.4 4.8 13 4.5 19.8 1 1-.5 2-1.6 3.4-1 .3 1 1 2 1 2.9.2 2 2.7 4.3-.3 6.2-10.3-.2-21 .6-31.2-.6-2.9-.3-6.5-2-5.5-5.7.9-3.2 6.6-3.8 9.2-4.5Z",
    className: "cls-23"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3 113c-4.2-4.4-8.4-8.8-12.4-13.3-1.9-2-3.8-3.7-6.4-4.6l-4-1.1.4-4H75c4.6 1.2 7.1 4.6 7.3 10.5.2 4.1 0 8.3 0 12.5Z",
    className: "cls-25"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M602.8 354.6c3-1.9.5-4.1.4-6.2-.1-1-.7-1.9-1.1-2.9h.3l33 .1c-2.3 1.1-5-.2-7.4 1.2-.6 2.2-.6 4.5.2 7.4H652v.4h-49.2Z",
    className: "cls-30"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m261.6 45-4.4 7V28c.1-1.8 1.8-2.6 3.6-2.6h26.6c2.6 0 3.8 1.5 3.8 4V40c.1 3.4-1.6 4.7-4.9 4.7h-20.8l-4 .2Zm-2.1-2.8h29.4c.5-5 .8-9.6-.1-14.3h-29.3v14.3Z",
    className: "cls-47"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M373.5 89.4c-7.4 7.8-13.8 16.3-20.6 24.5 0-6.1-1.8-16.1 2.6-21.3 4-4.8 12.5-3.2 18-3.2Z",
    className: "cls-25"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M580 50.5c-1.3-2.2-2.5-4-3.8-6.4h-21.6c-8 0-8.3-.3-8.4-8.4 0-12.3 0-11 11-11H576c3.2 0 4.7 1.4 4.7 4.7v20l-.6 1.1Zm-1.8-23.1h-29.4c-.4 4.9-.5 9.3 0 14.3h29.8c0-4.5.5-9.3-.4-14.3Z",
    className: "cls-47"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M238.6 89.9c-.7-.6-1-1.4-.6-2.3 5.8 0 15.2-1.9 19.7 3s2.6 14.5 2.6 20.5l-8.1-9.7c-2.2-6.6-7.8-9.2-13.6-11.5Z",
    className: "cls-25"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M212.8 349.5c3.8-.2 10.3.8 13.7-1.4 4-2.7 1-6-2.2-7.2l2-1.3v-59.2l.2-3.5h.5v63.6c5.9-.5 11.2.7 16.6-.6l2.4 2.2-.6 1.7c-.2 2-2.2 3.8 0 5.7h-32.6Z",
    className: "cls-30"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M106.4 338.7c.4 4.4 1.9 5.5 8.2 5.8l-1.5.7c6 4 14.4 3.3 19.6-1.3 2.4.5 6 .5 6.6 3.4.9 3.6-2.6 4.5-5.3 4.7-9.1.5-19.2.6-28.1-.8l-.1-8.6v-.5l.6-3.4Z",
    className: "cls-42"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M688 354h-22.8c-1-3-.4-5.8-.6-8.5h23.2c.6 3 .4 5.8.1 8.6Z",
    className: "cls-61"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m602.2 89.4 2.3-2.3c-.4-4.1-2.5-8.2-1.2-12.6l3.7 5.2 19.2-5.7h.5l.1.4c.5 5.7-2.7 9-7.3 11.4-4.4 2.3-8.4 1.4-12.3-2.4-1 2.8-2 5.2-4.4 6.6l-.6-.6Z",
    className: "cls-58"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m65.8 351.3-.6-.6c.2-2.6-.4-5.2.5-8 2.5 1.7 5 2.7 7.6 3.4 6.6 2.4 13 2.1 18.7-2.3 2.6.3 5.3.5 6.5 3.4.8 2-1 3-2.4 4-10 1.2-20.2.5-30.3 0Z",
    className: "cls-42"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6 340.4c-.3 3-2.4 5.8-1.7 9h-14.2c-3 0-4.6-1.3-4.6-4.4 0-3.1 1.5-4.5 4.6-4.5h16Z",
    className: "cls-30"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M152 267.1c-.8-1.8-.4-3.7-.4-5.6V227c4.4 4 5.7 9.3 5.4 15-.5 8.5-2.7 16.8-5 25Z",
    className: "cls-45"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M626.2 74 607 79.7l-3.6-5.2-.6-1.2.6-2.8h3.3a26.7 26.7 0 0 0 19.6-1.7V74Z",
    className: "cls-31"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8 70.6v-9.8a30.5 30.5 0 0 0 20.6 12.8c-3.8 4.3-11.8 4.2-20.5-.2v-2.8Z",
    className: "cls-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183 236.3c3.2-.2 6.5.5 9.7-.6.3 2.9-.8 6 2.3 8.1l-5.3 1-.4 5.3-.7-5.8h-11.1c.5-4.2 1.9-6.8 5.5-8Z",
    style: {
      fill: "#818181",
      strokeWidth: 0
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M626.2 68.8a26.7 26.7 0 0 1-19.5 1.6c4.7-.8 9.3-1.5 12.3-5.7 2.1-2.9 2.4-8.5 7.3-7.9v12Z",
    className: "cls-14"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m189.3 250.1.4-5.3 5.3-1h1.2l2.5 1.1-1.3 13.7V255c-3.6-.4-7.3-.3-8.1-4.8Z",
    className: "cls-6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M132.8 343.9a16.7 16.7 0 0 1-19.7 1.4l1.5-.8c3.8-.2 5.7-2.9 7.3-5.8 1.1 2.7 3.9 2.2 6 3.2 1.5.8 3.2 1.4 4.8 2Z",
    className: "cls-29"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.1 351.2c1.3-1 3.2-2 2.4-4-1.2-2.9-3.9-3.1-6.5-3.4l-.9-1.2h14.7v8.6h-9.7Z",
    style: {
      fill: "#5e5e5e",
      strokeWidth: 0
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M429.4 213.6a1 1 0 0 1-.4-.1c.4-9.7-1.3-19.2-3.4-28.6h4.5v28.5c-.2 0-.4 0-.7.2Z",
    className: "cls-25"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7 100.8h-.5c-.4-5.2.3-10 5.6-12.4 3-1.4 6.2-.6 9.3-.7-4 2.5-8.8 4.1-11.6 8.4-1.4 1.2-2 3-2.8 4.7Z",
    className: "cls-31"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M429.6 96.2c-4.7-1.7-10-2.5-13.2-6.8 6-1 10.5 1.2 13.2 6.8Z",
    className: "cls-25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M589 33.4c2.3 1.7 0 7.2-.4 9.5l3.2 1.4c-.6 1.4-1.8.9-2.8 1-.8 0-1.6-.2-2.7-.4.4-4 1.2-7.9 2.8-11.5Z",
    style: {
      fill: "#a3a3a3",
      strokeWidth: 0
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m101.2 152.2.4 4h32.9l9.6.2.2.4-.2.1h-43.4l.5-4.7Z",
    className: "cls-46"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M589.1 28.8c4-2.3 8.3-1.3 9.1 2.6-3-2-6-2-9-1v-1.6Z",
    className: "cls-57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.2 42.5c-3.3-.7-6.6-2-10 0 2.9-3 6-2.7 9.4-1.2l.6 1.2Z",
    style: {
      fill: "#404040",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.1 82 6.6 3.4-.5 1-7.2-3.9 1.1-.5Z",
    style: {
      fill: "#f0f0f0",
      strokeWidth: 0
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M154 140.3c-2.6 1-5.1 1.2-8.8 1.5 2.8-2 5-1.6 7-2l1.7.5Z",
    className: "cls-1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m420.4 156.3 9.2-.1.5.1v.5c-3.2-.2-6.5.6-9.7-.6Z",
    className: "cls-40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m248.9 34.5 1 .5-.5 1.3-.5-1.8Z",
    style: {
      fill: "#717171",
      strokeWidth: 0
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M552 290.6c.5.8.6 1.5.4 2.4l-.4-2.4Z",
    className: "cls-60"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m429.4 213.6.8-.2 1.6.6-2.4-.4Z",
    className: "cls-40"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m626.9 74.4-.2-.4 1.3.4h-1.1Z",
    className: "cls-31"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m266.2 337.4-1.4-.5 1.4.5Z",
    className: "cls-3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 120.8-.5-.4.5.4Z",
    className: "cls-25"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m155.6 140.8-.6-.5.6.5Z",
    className: "cls-1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M425.6 185c2.1 9.3 3.8 18.7 3.4 28.4l-8 3.5-1.2.5-31.3-2.7c-8.7-.8-17.4-1.5-26-3.6 0-9 2.3-17.6 4.6-26.2h58.5Z",
    className: "cls-40"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m607.4 207-4.4-6.8h-9.4l8.8-.7-6-14c1.1-.2 2.2-.6 3.3-.6h53.8c1 0 2-.2 3.1.7l.5 1.4.6 38.5c0 .8-.3 1.5-.5 2.2V206c-2.7 3-4.3 6-6.9 8.2-11.6 9.8-30.4 7.7-40.8-4.7l-2-2.3Z",
    className: "cls-4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M91 185v5c-.2-1-.6-1.8-.5-2.8.2-10.3-2-20.3-4-30.4 2 0 4.1.4 6.1-.5l8 .5 43.5.1v26.4c-1.5 1.4-2.9 1-4.2 1H95.2c-1.4 0-2.9-.2-4.2.6Z",
    className: "cls-22"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M652 354.2h-23.9a13 13 0 0 1 0-7.4c2.3-1.4 5-.1 7.3-1.2l.4-.1c1-1.4.7-3 .7-4.4v-76.6c0-1.4-.3-2.8.8-4.4l4.8-.7c.6-3.2-.5-6.4.8-10h14.2c0 3.2.4 6.3-.3 9.3-2.8 1.3-5.7-.1-8.2 1.1l-.1 1.5V343l.2 2.4h8.4v8.1c-1.7 1-3.4.4-5 .6Z",
    className: "cls-61"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M238.6 89.9c5.8 2.3 11.4 5 13.6 11.5A173 173 0 0 1 254 138l-2 16.5c-.9 2.5-2.7 2-4.6 1.4a7.8 7.8 0 0 1-.3-4.7l1-.2.7-.4.4-.6V149l-.5-.6-2.2-.7v.1-1.1l3.5-.5.4-.1.6-.6v-1.1l-.5-.6-.6-.5-3.4-.1v-1l1.7-.2h.5l.6-.5.4-.6v-.5l-.3-.7-.5-.5-3-.6-.5-3.5c-1-14.2-3.8-28-8.7-41.5.2-1.4.3-2.9 1.8-3.6Z",
    className: "cls-45"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M657 259.8h-8.4c2.5-1.2 5.5.2 8.2-1 .8-3.1.3-6.3.3-9.3-7.5-1.2-15.4-.6-23-.6-7.7 0-15.7-.5-23.3.6-4.5-.8-9-.4-13.4-.3-7.1 0-14.3-.6-21.5.3l-1.1-4 .4-.3-.4-.3c12.1-2 24.9-2.6 37.2-2.4 11.2.2 24.6 4.4 34.7-2.2l4 .6h6.6c.4 6.6 1 12.7-.2 18.9Z",
    className: "cls-44"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M216.1 184.9c-4.6 7-11 11.6-19.8 13.6v-4.3l.7-9.3h19.1Z",
    className: "cls-45"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 184.9c.2 5.7-.6 11.4.5 17l-7.6.6v-16.7c2.6-1.5 4.9-.8 7-1Z",
    className: "cls-60"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M664.6 249.5c3.6-.9 7.2-.6 11.2-.1v9.6c-3.5.5-7 .5-10.8 0-.8-3.3-.2-6.4-.4-9.5Z",
    className: "cls-57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m650.8 240.9-4.1-.6.7-.6c3.9-2.8 7-6.4 9.3-10.7 1 3.5.3 7 .3 10.4-2 1.6-4.4.5-6.2 1.5Z",
    style: {
      fill: "#bdbdbd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2 156.3h38.9c-1.7.8-3.6.5-5.4.5h-33.5v-.5Z",
    style: {
      fill: "#959595",
      strokeWidth: 0
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M229.3 156.3h8.6l.6-.6h.6c1.4.2 2.9 1.2 4-.5l2.9-.6h.4c0 1-.3 2.1-1.6 2.1-5.2 0-10.3.7-15.4-.4Z",
    className: "cls-16"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m608.5 155.7.6.6a10 10 0 0 1-7 0l.3-.1c2 0 4.1.5 6.1-.5Z",
    className: "cls-4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m246 151.7-.2-.4.7-.2v.6h-.5ZM246.4 154.5h-.4l.4-.4v.4Z",
    className: "cls-2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M246 151.7h.4v.6l-.4-.6Z",
    className: "cls-16"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2 156.3v.5h-.6l.6-.5Z",
    className: "cls-14"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m574.8 245 .4.2-.4.3v-.6Z",
    className: "cls-25"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m647.4 239.7-.6.6.6-.6Z",
    className: "cls-44"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M362.6 211.1c8.5 2.2 17.2 2.9 26 3.6l31.1 2.7a206.8 206.8 0 0 0 4.1 1.2h2.3l1.1.6h1.2l1.1.5h1.7l.6.6h1.7l.6.6h1.2l.5.5h1.2l.5.6 1.8.6c.8 1.1 2 1.6 3.4 1.7l1.1.6 10.3 8.5.6.6.6.6 1.1 2.3c-6.5 3-13 6.2-19.5 9.1-2.7 1.2-4.7 2.6-5 5.7v-3.6l-6.4-1-14.3-2.1c-8-1.3-16.1-2.4-24.2-3.8a31.8 31.8 0 0 1-25-27.4c-.1-.9-.7-2 .6-2.7Z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m455.3 262.1-.5-1.1 1-4.3.7.2-1.2 5.2Z",
    style: {
      fill: "#ababab",
      strokeWidth: 0
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M235.6 213c8.4-1.2 16.8-1.7 25.3-1.1 1 1.6-3.8 3.5-4.9 4.5-2 2-3.2 4.3-3.8 6.9-1.8 6.7-1.3 13.8-3.2 20.4h-15c1.6-10.7 4.9-22.3-5.6-29.8l7.2-1Z",
    className: "cls-53"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m248.2 254.7-16.5.1 1.7-9.8c5.1-1.4 10.3-.5 15.9-.6l-1.1 10.3Z",
    className: "cls-6"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M226.4 280.4v59.2l-2 1.3-10-2.8-.5-1.2c1.6-2.1 2-4.7 2.3-7.2 2.7-16.6 6.2-33 10.2-49.3Z",
    className: "cls-7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M196.2 243.8H195c-3-2-2-5.2-2.2-8 0-2.4.3-4.8 0-7.2-.9-8.4 1-16.4 4-24.4 1.5 5 5.1 7.8 10.3 8.8.5.2 1 .5 1.6 1-11 7-6.6 19.2-10.5 29.6 0 .2-1.1 0-2 .2Z",
    className: "cls-53"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m227.1 275.8-.1 1.1h-.5l.6-1.1Z",
    className: "cls-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m214 337 .5 1-.6.1V337Z",
    style: {
      fill: "#bbb",
      strokeWidth: 0
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m602.2 89.4.6.5-5.7 8-.1-1c.6-3.3 3-5.4 5.2-7.5Z",
    className: "cls-61"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m630.4 155.7.4-.5-.4.5Z",
    className: "cls-46"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3 346c-2.6-.6-5.1-1.6-7.6-3.3-.8 2.8-.3 5.4-.4 8-1-5.4-1.2-10.7 1.8-15.6 2-3.3 4.1-6.4 6.2-9.5l.5-1.3 2.6-4.7a255.9 255.9 0 0 0 25.7-63.8c.8-3.2.2-5.7-2.5-7.5l-12-2.8-36.7-8.5-.5-.1-1.2-.5-9.4-2.4c-10.4-3-14.7-11.3-11.2-21.8.2 4 7.4 2.4 9.8 2.4 3.2 0 10.6 1.5 13-1.2 1 2.1 2.9 1.1 4.3 1.1h27.8l8 3c7.2 3.6 15.3 4.7 22.2 8.8 6.3 3.6 11.4 8.2 13.2 15.5.3 1.2.9 2 1.9 2.4-2.3.7-1.8 2.5-1.7 4.2-2.5 16-10.2 32.5-17.7 46.7-8 15.6-18.4 29.6-28.2 44-1.6 3.5-4.7 5.3-7.9 7Z",
    className: "cls-27"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 212.2c-3.5 10.5.7 18.8 11.2 21.8l9.4 2.4 1.2.5h.5c-8.4.9-16.8.1-25-.4-3.7-.2-5-3.9-5.2-7.3V100.9c0-3.6.2-7.1-2.2-11h25v1.7c-1.3 2.7-2 5.6 0 8 5.3 6.7 14.3 5.8 18.3-1.7 5.4 7.2 9.3 15.3 14 22.9 1.5 2.3 12.8 18.7 8.3 20-18.5-12.1-36.4-25-46.6-45.6l-.6-.6c-12.2 3.3-16.3 9.8-13.4 20.2 3 10.4 7.6 20 11.6 30A53.9 53.9 0 0 1 37 179l-8.3 33.2Z",
    className: "cls-25"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m87.5 245.5 12 2.8c-3 2 0 5.4-2.2 8.2h-24c0 1.1-.3 1.8-.3 2.4V322c0 .9 0 1.8.8 2.3l-.5 1.3c-1-1.3-.7-2.8-.7-4.2V261c0-1.3.3-2.7-.5-3.9-1.4-1.2-3.2-.2-5.2-1.3v-9.6h17.6l3-.6Z",
    className: "cls-6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 212.2 37 179c3-11.6 2.7-22.9-1.8-34.1-4-10-8.6-19.7-11.6-30.1-2.9-10.4 1.2-16.9 13.4-20.2l.6.6c10.2 20.6 28 33.5 46.6 45.6 5.5.5 11 .2 16 1.3 1.2 1 1 2 1.3 2.9l-.2 7.2-.5 4.6-8-.5H92l-3.4-.6c-.9.2-2.1-.6-2.2 1 2 10.1 4.2 20.2 4 30.5 0 1 .3 1.9.4 2.8l.2 19.8.5 7.7-8-3v-.5c.9-8 .9-16 0-24-.8-11.6-1.3-23.1-3.4-34.7a86.3 86.3 0 0 1-26-11.7l-.3 1 .3 2c3.3 22.4 2.7 44.7-2.8 66.8-2.4 2.7-9.8 1.2-13 1.2-2.4 0-9.6 1.5-9.8-2.4Z",
    className: "cls-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.6 246.1H128l-1 2.3c0-1.7-.5-3.5 1.8-4.2l2.8 1.9Z",
    style: {
      fill: "#797979",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1 52.2c-.8 1.4-.5 3-.6 4.6L40 55.6c-1.2-2.8-2.5-5.6 1.3-8l2.8 4.6Z",
    style: {
      fill: "#b6b6b6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.1 55.6 3.4 1.2c0 .9.3 1.7-.6 2.3-1.2-.9-2.6-1.5-3.4-2.9l.6-.6Z",
    style: {
      fill: "#444",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.1 31.5c7.5-2.7 5.9 9.6 1.7 12.4.1-4.3-.9-8.3-1.7-12.4Z",
    style: {
      fill: "#9c9c9c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.5 155.7c-2 1-4 .5-6.1.5l1.5-6.2 4.6 5.7Z",
    style: {
      fill: "#343434",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.7 94.5c1.1.1 2.3.2 2.7 1.7-1.6.3-2.3-.3-2.7-1.7Z",
    style: {
      fill: "#777",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.5 91.1c1.4 0 2.5.4 3.6 1.7-1.7.2-2.7-.6-3.6-1.7Z",
    style: {
      fill: "#7d7d7d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.7 98.6c.5-.1.8 0 .9.6-.5.1-.9 0-1-.6Z",
    style: {
      fill: "#9a9a9a",
      strokeWidth: 0
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M232.2 136.3c.7-3.9 3.2-7 4-11 1.3-7.7.1-14.9-3.8-22.3 2 1 2.4 2.4 3.1 3.6a30.9 30.9 0 0 1 3.2 23.4c-.3 1.3-.5 2.7-1.9 3.4-2.1 0-3 2-4.6 2.9Z",
    className: "cls-40"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M197.3 141c6.2 0 12.3.2 18.5.3h-18.4v-.4Z",
    className: "cls-46"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M246.5 146.6v1h-5.1v-1h5.1Z",
    className: "cls-18"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M246 143.1h-4.4v-.5l4.4-.6v1.1ZM243.1 155.2c-1.1 1.6-2.6.7-4 .5 1.3-.7 2.7-.6 4-.5Z",
    className: "cls-2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m250.1 146.1-3.6.5c1.1-.8 2.4-.6 3.6-.5ZM222.5 141.4V138l.6 3.4h-.6ZM245.5 135l.5 3.5h-.5V135ZM246 138.5l3 .5-3-.5Z",
    className: "cls-46"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m197.3 141 .1.3c-1 0-2-.2-2.9-.4h2.8Z",
    className: "cls-14"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m246.6 147.6 2.2.7-2.3-.7Z",
    className: "cls-46"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M241.4 146.6v1.1-1.1Z",
    className: "cls-2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M246 143.1V142h.6v1l-.6.1ZM249.8 140.8l-.4.6v-.5l.4-.1Z",
    className: "cls-46"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m238.5 155.7-.5.6.5-.6ZM249.3 150l-.5.6.5-.6Z",
    className: "cls-2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m248.8 148.3.5.5-.5-.5ZM191 135.7c0 .3-.3.5-.4.8l.5-.8ZM190.5 136.8l-.5.8.5-.8ZM251 145.4l-.5.6.6-.6Z",
    className: "cls-46"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m248.8 141.8-.3.1h-.2l.5-.5v.4Z",
    className: "cls-2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m189.8 138-.4.7.4-.7Z",
    className: "cls-46"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m250.5 143.6.6.7-.6-.7Z",
    className: "cls-2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M248.8 141.8v-.4h.6l-.6.4Z",
    className: "cls-46"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m250 143.2.6.5-.6-.5Z",
    className: "cls-2"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m189.2 139.1-.4.7.4-.7Z",
    className: "cls-46"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m191.7 134.6-.6.8.6-.8Z",
    className: "cls-14"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m192 134-.3.6.4-.6ZM249.5 139.6l.4.7h-.5l.1-.7ZM192.7 132.8l-.4.7.4-.7Z",
    className: "cls-46"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m248.9 150.6-.6.4.6-.4Z",
    className: "cls-2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M188.7 140.3Z",
    className: "cls-46"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M249.4 140.2h.5l-.1.6h-.4v-.6Z",
    className: "cls-14"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m193.3 131.7-.4.7.4-.7Z",
    className: "cls-46"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M213.3 50c-5-1.3-7-3.7-7-8.5 0-4 2.4-5.3 6.1-3.5 1.3 2.8-.6 6.2 1.5 9l-.6 3Z",
    className: "cls-18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.6 41.5c2.4 4 2.9 7.5 3.8 11a6.5 6.5 0 0 1-6 .4c.7-1.6 2.4-.8 3.3-2 .3-2.8-2.2-5.4-1-9.4Z",
    style: {
      fill: "#a0a0a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8 38.8c-3.4-1.3-6.6-1.5-9.8.9.2-4.9 8.1-4.9 9.9-1Z",
    style: {
      fill: "#3d3d3d",
      strokeWidth: 0
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M230.8 34c-3.5.3-6.3 1.7-8 4.9-2.4-4.3 4.8-7.3 8-5Z",
    className: "cls-61"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M241.7 43.1c-.6-1.5-.1-2.4 1.3-2.9 1.4.2 2 1 1.8 2.4-.9 1.3-2 1.1-3.1.5ZM228.1 43.4c-1 .8-2 .9-3 .2-1.2-3.2 3.6-3.8 3-.3Z",
    className: "cls-27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.8 98c-4 7.4-13 8.4-18.4 1.7-2-2.5-1.2-5.4.1-8 7.2 3.7 9 5.1 11.8 9.4 1.8-2.2 4-4 4.3-7.1l4 1-2.1.2c-.6 1.1 0 2 .3 2.7Z",
    style: {
      fill: "#acacac",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 78.3c-3.5 3.2-10.4 4-13.6 2-1-.6-1.8-1.4-1.8-2.7V64a27.5 27.5 0 0 0 15.4 14.4Z",
    style: {
      fill: "#b7b7b7",
      strokeWidth: 0
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60c-2.2 1-4 1.1-6 .2.7-1.8 2.5-.6 3.4-1.9.6-2.8-2.2-5.7-.7-9.8 2.3 4.1 2.8 7.8 3.3 11.6Z",
    className: "cls-47"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8 52.3c-2.1-1.2-2-2.7-.9-4.3 1.2-.5 2.1-.4 3.3 0-.7 1.4.1 3.5-2.4 4.3Z",
    className: "cls-57"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2 47.5c1.4 2.1 1.4 3.6-.7 4.6-2.4-.6-1.6-2.7-2.3-4.3l3-.3Z",
    className: "cls-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.3 43.2c-4-2.2-7.2-2.2-10.5-.5 1.5-3.4 7.2-3.5 10.5.5Z",
    style: {
      fill: "#474747",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.3 52.9v14.2c.1 2.6-1 4-3.5 4.6-4.3.8-8.3.5-11.8-2.4 0-1 .6-1.7 1.6-2 6.8-2.7 11-7.9 13.7-14.4Z",
    style: {
      fill: "#1c1c1c",
      strokeWidth: 0
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M384.4 50.7c-2.2.3-4 1.3-6.2-.2.6-3.6 1.4-7.2 3.4-10.5 1.4 3.2-1 6-.9 9 .9 1.3 2.3.5 3.7 1.7ZM373.2 42.8c-1.8-.7-2-2.1-1.9-3.7 2.9-1.8 5 2.3 2 3.7Z",
    className: "cls-48"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M390.8 42.1c-3.6.7-2.5-5.3.8-3.3.4 1.3.3 2.4-.8 3.3Z",
    className: "cls-8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7 100.8c.8-1.6 1.4-3.4 2.8-4.7l.8.8c-1.3 1.2-1.5 3.4-3.6 3.9Z",
    className: "cls-57"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m454.1 233.5-10.3-8.6c4.5 1.6 8 4.5 10.3 8.6ZM442.7 224.3a4.4 4.4 0 0 1-3.4-1.7l3.4 1.7ZM439.2 222.6l-1.7-.6 1.7.6ZM423.8 218.6l-1.7-.6 1.7.6Z",
    className: "cls-42"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m419.8 217.4 1.1-.5-1.1.5Z",
    className: "cls-3"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m427.2 219.2-1.1-.6 1.1.6ZM429.5 219.8l-1.1-.6 1.1.6ZM454.7 234l-.6-.5.6.5ZM435.8 221.5l-.6-.6.6.6ZM437.5 222l-.5-.5.5.5ZM455.3 234.6l-.6-.6.6.6ZM431.8 220.3l-.6-.6.6.6ZM434.1 220.9l-.6-.6.6.6Z",
    className: "cls-42"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M595.9 35c-1.1.8-2 .9-3 0-.3-1.3.1-2.2 1.4-2.7 1.8.3 1.8 1.4 1.6 2.8Z",
    style: {
      fill: "#353535",
      strokeWidth: 0
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m245.4 343.8.6-1.7-.6 1.7Z",
    className: "cls-3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2 339.2c2.5 2 5.5 2.8 8.7 2.9h15.9v.5H91l1 1.2c-5.9 4.4-12.2 4.7-18.8 2.3 3.2-1.7 6.2-3.5 8-7Z",
    className: "cls-29"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 156.8c0-1.7 1.3-.9 2.2-1l3.4.5h.5c-2 .9-4 .4-6.1.5Z",
    style: {
      fill: "#838383",
      strokeWidth: 0
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M635.9 345.5v-85.7h-25.1v-10.3c7.6-1 15.6-.6 23.3-.6 7.6 0 15.5-.6 23 .6H643c-1.3 3.5-.2 6.7-.8 10l-4.8.6c-1 1.6-.8 3-.8 4.4v76.6c0 1.5.3 3-.7 4.4Z",
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.4 213.4a172.1 172.1 0 0 0 2.5-68.8l.3-1c8.1 5 16.5 9.5 26 11.7 2 11.6 2.6 23.2 3.4 34.7v24.6H55.6c-1.4 0-3.3 1-4.3-1.2Z",
    style: {
      fill: "silver",
      strokeWidth: 0
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m50.4 236.9-1.2-.5 1.2.5Z",
    className: "cls-44"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6 214v-24c.9 8 .9 16 0 24Z",
    className: "cls-27"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m92.1 156.3-3.4-.6 3.4.6Z",
    className: "cls-22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSharedConversations);
export default __webpack_public_path__ + "static/media/noSharedConversations.67e372d2b61a5fb64ebb1572fd57ef1e.svg";
export { ForwardRef as ReactComponent };